import type { Metier } from "models/ContactsMetiers";
import { cometApiClient } from "./apiClients";
import { Endpoints } from "constants/endpoints";

/**
 * Récupère le référentiel de tous les métiers
 * @returns Array<Metier>
 */
async function getAll(): Promise<Array<Metier>> {
  const url = Endpoints.METIERS;
  const response = await cometApiClient.get<Array<Metier>, Array<Metier>>(url);

  return response.sort((m1, m2) => m1.libelle.localeCompare(m2.libelle));
}

export const metiersService = {
  getAll,
};
